const palette = {
  primary: {
    main: "#FE8033",
    contrastText: "#fff",
    light: "#ff9300",
    higher: "#f37021",
    lighter: "#fde1bb",
    blue: "#06255a",
    blueBright: "#023ff6",
    blueBrightBg: "#e6f0ff",
    darkBlue: "#001b37",
  },
  secondary: {
    main: "#FDE2D2",
    contrastText: "#000",
    higher: "#fcd4bb",
    light: "#fef1ea",
  },
  peach: {
    main: "#ffd9a8",
    secondary: "#fef5ea",
  },
  info: {
    main: "#00afeb",
    secondary: "#30c5bd",
    contrastText: "#fff",
    hover: "#219b94",
    button: "#7066e0",
    cyan: "#00b5ec",
  },
  success: {
    main: "#75b93e",
    secondary: "#669c35",
    contrastText: "#fff",
    muted: "#449754",
    dark: "#057231",
    lighter: "#eaf5dc",
  },
  danger: {
    main: "#d1181f",
    secondary: "#FFC0C0",
    hover: "#7a0101",
    contrastText: "#fff",
  },
  warning: {
    main: "#ffd800",
    contrastText: "#fff",
    dark: "#ffc100",
    yellow: "#feb017",
  },
  grey: {
    lighter1: "#f0f0f0",
    lighter2: "#dcdcdc",
    lighter3: "#e8e8e8",
    lighter4: "#f0f1f5",
    darker1: "#84818a",
    steel: "#aab0c5",
    rgb: [
      "rgb(214, 222, 224)",
      "rgb(244, 244, 244)",
      "rgb(245, 245, 245)",
      "rgb(248, 248, 248)",
    ],
  },
  darkgrey: {
    main: "#ddd",
  },
  cancel: {
    main: "#6e7881",
  },
  yellow: {
    main: "#ffc100",
    contrastText: "#000",
    lighter1: "#fef2cc",
    rgb: [
      "rgb(255, 194, 0)",
      "rgb(223, 157, 4)",
      "rgb(250, 209, 38)",
      "rgb(243, 182, 74)",
      "rgb(253, 170, 61)",
      "rgb(254, 248, 239)",
      "rgb(247, 239, 225)",
    ],
  },
  gold: {
    main: "#ffab00",
  },
  background: {
    default: "#fff",
    main: "#fbfafc",
    activity: "#fbfafc",
    grade: "#f5f5f5",
    secondary: "#f5f1f8",
    primaryLight: "#fff5e9",
    micButton:
      "transparent linear-gradient(180deg, #4EC2D5 0%, #4B98B0 100%) 0% 0% no-repeat padding-box",
    card: "#f0f0f0",
    image: "#F5F2F9",
    modal: "#f9fafb",
    backdrop: "rgba(0, 0, 0, 0.6)",
    interview: "#e3f3f3",
    notes: "#fddab8",
    hover: "#f2f2f2",
    orange: "#FE8033",
    mission: "#fff",
    lightblue: "#e9edf5",
    icon: "#A0A0A0",
    lighter: "#EAEAEA",
    avatar: "#d0ecf4",
    auth: "#F6F8FC",
    orangeDark: "rgba(252, 106, 39, 0.15)",
    placeholder: "#eeeeee",
    editor: "#1a1a1a",
  },
  wave: {
    main: "#4ec2d5",
    dark: "#4b98b0",
  },
  exam: {
    main: "#27ade2",
    button: "#28a745",
    disabled: "#8d8c8d",
    dark: "#0d729a",
  },
  selected: {
    main: "#4EC2D5",
    dark: "#4B98B0",
  },
  gradeChanged: {
    main: "#7d3192",
  },
  link: {
    main: "#053096",
  },
  dropdown: {
    main: "#FF6364",
    contrastText: "#fff",
  },
  border: {
    primary: "#ebeaed",
  },
  menu: {
    contrastText: "#5e5f62",
  },
  text: {
    lighter1: "#84818a",
    lighter2: "#333",
    lighter3: "#202124",
    lighter4: "#3c4043",
    expired: "#dd0707",
    selected: "#2831ff",
    professor: "#7f8c8d",
    title: "#2c3e50",
  },
  grades: {
    completed: "#75B93E",
    start: "#b7db9d",
    end: "#b7db9d",
    low: "#f8d7da",
    medium: "#d1ecf1",
    high: "#d4edda",
  },
  level: {
    completed: "#f9fcf8",
    message: "#f0f6eb",
    border: "#eaf2e7",
  },
  common: {
    white: "#ffffff",
    black: "#000000",
  },
  hover: {
    main: "#e0e0e0",
  },
  orange: [
    "rgb(240, 92, 18)",
    "rgb(240, 133, 18)",
    "rgb(252, 142, 0)",
    "rgb(253, 143, 0)",
    "rgb(254, 243, 235)",
    "rgb(252, 164, 53)",
  ],
  red: ["rgb(255, 84, 79)", "rgb(192, 69, 8)", "rgb(234, 87, 53)"],
  brown: ["rgb(151, 85, 0)", "rgb(214, 222, 224)"],
  green: [
    "rgb(62, 199, 39)",
    "rgb(7, 157, 43)",
    "rgb(238, 250, 236)",
    "rgb(11, 137, 76)",
  ],
  blue: ["rgb(29, 154, 203)", "rgb(235, 246, 250)"],
  blueBright: {
    main: "#023ff6",
    dark: "#06255a",
    light: "#e6f0ff",
    contrastText: "#fff",
  },
  pink: {
    main: "#ff5a79",
  },
  purple: {
    rgb: ["rgb(119, 118, 255)", "rgb(174, 44, 241)", "rgb(106, 7, 157)"],
    main: "#4e31e4",
    bright: "#731efc",
    deep: "#3901c2",
    dark: "#150c69",
    light: "#ece8fc",
    pale: "#f5f9fd",
    muted: "#efecfd",
  },
  grade: {
    low: "#f4c1bc",
    medium: "#fee4ce",
    high: "#c8dabc",
    text: {
      low: "#c62828",
      medium: "#0369a1",
      high: "#2e7d32",
    },
    dark: {
      low: "#fe9089",
      medium: "#fed3ad",
      high: "#bad6a9",
    },
  },
  icons: {
    success: "#7DC242",
    wrong: "#ED1C24",
    disabled: "#5c606e",
  },
  stepper: {
    main: "#c6c7ca",
  },
  games: {
    main: "#4e47e3",
    primary: "#032fc6",
    secondary: "#fe5d16",
    third: "#0a8008",
    timesup: "#fce4e7",
    success: "#edfcf5",
    successText: "#388E3C",
    successSurface: "#E8F5E9",
    successBorder: "#81C784",
    error: "#fff1f1",
    errorText: "#D32F2F",
    errorSurface: "#FFEBEE",
    errorBorder: "#E57373",
    text: "#5F6368",
    disabledSurface: "#E0E6ED",
    disabledText: "#D0D5DD",
    explanationSurface: "#e6f5f3",
    explanationBorder: "#b3e0db",
    explanationText: "#004D40",
    messageAlertSurface: "#FFFDF0",
    messageAlertBorder: "#FFD54F",
    surfaces: {
      success: "#E8F5E9",
      error: "#FFEBEE",
      explanation: "#e6f5f3",
      message: "#FFFDF0",
      translations: "#F0EEFF",
      cell: "#F1F5F9",
      darkCell: "#E2E8F0",
      placeholder: "#F4F6F8",
    },
    borders: {
      success: "#81C784",
      error: "#E57373",
      explanation: "#b3e0db",
      message: "#FFD54F",
      translations: "#C2C9FF",
    },
    texts: {
      success: "#388E3C",
      darkSuccess: "#1B5E20",
      error: "#D32F2F",
      explanation: "#004D40",
      message: "#854D0E",
      translations: "#3F51B5",
      instructions: "#9E9E9E",
    },
    favorite: {
      main: "#f24e1e",
    },
    disabled: {
      main: "#B0BEC5",
    },
    buttons: {
      primary: "#1b5ce3",
      secondary: "#edf4fe",
    },
  },
  licenses: {
    surface: "#0d2747",
    icons: "#DBEAFE",
    surface2: "#eff2f8",
    text: "#eff2f8",
    text2: "#a4a8b0",
    text3: "#6B7280",
    text4: "#4B5563",
    border: "#D1D5DB",
    border2: "#E0EFFF",
    border3: "#F1F5F9",
    surface3: "#fef6e9",
    surface4: "#e9f0fd",
    surface5: "#e9f5ea",
    surface6: "#efecfc",
    surface7: "#fef8f0",
    surface8: "#feb017",
    actions: "#2563EB",
    success: "#10B981",
    surface9: "#F0F7FF",
    surface10: "#F8FAFC",
    surface11: "#FE8033",
    surface12: "#2563EB",
    surface13: "#10B981",
  },
  dividers: {
    main: "#0000001f",
  },
  auth: {
    forgotPasswordMain: "#6734cd",
  },
  activity: {
    main: "#1b5ce3",
    contrastText: "#cacace",
  },
  alerts: {
    confirm: "#2a9844",
    cancel: "#d33",
  },
  professor: {
    pageBackground: "#F5F7FA",
    checkboxUnchecked: "#CBD5E1",
    link: "#0a198f",
    blue: "#002184",
    banner: {
      surface: "#ECFDF5",
      border: "#A7F3D0",
      text: "#065F46",
      icon: "#059669",
    },
    groups: {
      pedagogical: {
        orange: "#FF641A",
        purple: "#7300A8",
        green: "#389937",
        blue: "#2945F5",
        gray: "#6B6F78",
      },
    },
  },
}

const darkPalette = {
  primary: {
    main: "#e77f33",
    contrastText: "#E6E6E6",
    light: "#FFB380",
    higher: "#f37021",
    lighter: "#4a3828",
    peach: "#fde1bb",
    blue: "#d1d5db",
    blueBright: "#4d8cf4",
    blueBrightBg: "#1a2536",
    darkBlue: "#38bdf8",
  },
  secondary: {
    main: "#b0b8c4",
    contrastText: "#313131",
    higher: "#574941",
    light: "#313131",
  },
  success: {
    main: "#5d8f31",
    secondary: "#466e25",
    contrastText: "#E6E6E6",
    muted: "#449754",
    bright: "#22c55e",
    dark: "#057231",
    lighter: "#2d3a24",
  },
  info: {
    main: "rgba(22, 146, 177, 1)",
    secondary: "#48a9c5",
    contrastText: "#fff",
    hover: "#2db9db",
    button: "#6a5acd",
    cyan: "#00b5ec",
  },
  danger: {
    main: "#b94141",
    secondary: "#3d2323",
    hover: "#ff867f",
    contrastText: "#E6E6E6",
  },
  warning: {
    main: "#ffcc00",
    dark: "#e6b800",
    contrastText: "#000",
    yellow: "#feb017",
  },
  hover: {
    main: "#6e6d6d",
  },
  peach: {
    main: "#f9b066",
  },
  grey: {
    lighter1: "rgb(160, 160, 160)",
    lighter2: "#323232",
    lighter3: "#636262",
    lighter4: "#252b31",
    steel: "#aab0c5",
    rgb: [
      "rgb(75, 83, 85)",
      "rgb(180, 180, 180)",
      "rgb(160, 160, 160)",
      "rgb(220, 220, 220)",
    ],
  },
  purple: {
    rgb: ["rgb(83, 75, 194)", "rgb(144, 44, 201)", "rgb(106, 7, 157)"],
    main: "#4e31e4",
    bright: "#731efc",
    deep: "#3901c2",
    darker: "#150c69",
    light: "#ece8fc",
    pale: "#f5f9fd",
    muted: "#efecfd",
  },
  grade: {
    low: "#f4c1bc",
    medium: "#fee4ce",
    high: "#c8dabc",
    text: {
      low: "#c62828",
      medium: "#0369a1",
      high: "#2e7d32",
    },
    dark: {
      low: "#fe9089",
      medium: "#fed3ad",
      high: "#bad6a9",
    },
  },
  pink: {
    main: "#ff5a79",
  },
  blueBright: {
    main: "#4d8cf4",
    dark: "#06255a",
    light: "#1a2536",
    contrastText: "#fff",
  },
  yellow: {
    main: "#FFD54F",
    contrastText: "#000",
    lighter1: "#545658",
    rgb: [
      "rgb(255, 213, 79)",
      "rgb(223, 178, 70)",
      "rgb(250, 219, 92)",
      "rgb(243, 201, 128)",
      "rgb(253, 196, 122)",
      "rgb(254, 251, 245)",
      "rgb(247, 242, 232)",
    ],
  },
  exam: {
    main: "#0d3b4d",
    button: "#28a745",
    disabled: "#8d8c8d",
    dark: "#0d3b4d",
  },
  background: {
    default: "#1d2329",
    main: "#1a1a1a",
    activity: "#1a1a1a",
    primaryLight: "#0c1a27",
    grade: "#1a1a1a",
    secondary: "#242424",
    micButton:
      "transparent linear-gradient(180deg, #3A9FB0 0%, #2D6A7D 100%) 0% 0% no-repeat padding-box",
    card: "#2d2d2d",
    image: "#1d2329",
    modal: "#1e1e1e",
    backdrop: "rgba(0, 0, 0, 0.85)",
    interview: "#2d373d",
    notes: "#574941",
    hover: "#2a2a2a",
    orange: "#252525",
    mission: "#2d373d",
    lightblue: "#212832",
    icon: "#cbd5e1",
    lighter: "#333a45",
    avatar: "#d0ecf4",
    auth: "#F6F8FC",
    orangeDark: "rgba(252, 106, 39, 0.15)",
    placeholder: "#eeeeee",
    editor: "#1a1a1a",
  },
  grades: {
    completed: "#3a5d1f",
    start: "#2d451e",
    end: "#2d451e",
    low: "#442729",
    medium: "#1d3a40",
    high: "#213a28",
  },
  level: {
    completed: "#222621",
    message: "#232921",
    border: "#2d352b",
  },
  common: {
    white: "#000000",
    black: "#E6E6E6",
  },
  menu: {
    contrastText: "#d5d6daff",
  },
  text: {
    lighter1: "#E6E6E6",
    lighter2: "#E6E6E6",
    lighter3: "#ccc",
    lighter4: "#ddd",
    expired: "#fc5a5a",
    selected: "#4dabff",
    professor: "#7f8c8d",
    title: "#2c3e50",
  },
  selected: {
    main: "#82b1ff",
    dark: "#6b7280",
  },
  border: {
    primary: "#1e1e1e",
  },
  icons: {
    success: "#8BC34A",
    wrong: "#D32F2F",
    disabled: "#a0a5b1",
  },
  stepper: {
    main: "#3f444e",
  },
  games: {
    main: "#4e47e3",
    primary: "#1a6488",
    secondary: "#f3702b",
    third: "#49ab27",
    timesup: "#fce4e7",
    success: "#edfcf5",
    successText: "#388E3C",
    successSurface: "#E8F5E9",
    successBorder: "#81C784",
    error: "#fff1f1",
    errorText: "#D32F2F",
    errorSurface: "#FFEBEE",
    errorBorder: "#E57373",
    text: "#5F6368",
    disabledSurface: "#E0E6ED",
    disabledText: "#D0D5DD",
    explanationSurface: "#e6f5f3",
    explanationBorder: "#b3e0db",
    explanationText: "#004D40",
    messageAlertSurface: "#FFFDF0",
    messageAlertBorder: "#FFD54F",
    surfaces: {
      success: "#1b2e23",
      error: "#331a1d",
      explanation: "#192c2a",
      message: "#2d2a1b",
      translations: "#222138",
      cell: "#252b31",
      darkCell: "#1e242a",
      placeholder: "#3b4554",
    },
    borders: {
      success: "#2e7d32",
      error: "#c62828",
      explanation: "#00695c",
      message: "#a16207",
      translations: "#4f46e5",
    },
    texts: {
      success: "#4ade80",
      darkSuccess: "#86efac",
      error: "#f87171",
      explanation: "#2dd4bf",
      message: "#fde047",
      translations: "#818cf8",
      instructions: "#94a3b8",
    },
    favorite: {
      main: "#ff6b3d",
    },
    disabled: {
      main: "#475569",
    },
    buttons: {
      primary: "#3b82f6",
      secondary: "#232d3d",
    },
  },
  licenses: {
    surface: "#d1d5db",
    icons: "#60a5fa",
    surface2: "#1a1a1a",

    text: "#f1f5f9",
    text2: "#94a3b8",
    text3: "#eff1f3ff",
    text4: "#c0d1e9ff",

    border: "#334155",
    border2: "#1e3a8a",
    border3: "#333a45",

    surface3: "#2d261e",
    surface4: "#1e2433",
    surface5: "#1e261f",
    surface6: "#252233",
    surface7: "#2d2924",
    surface8: "#f59e0b",

    actions: "#265196",
    success: "#10b981",

    surface9: "#1e293b",
    surface10: "#242b33",
    surface11: "#ff924d",
    surface12: "#3b82f6",
    surface13: "#34d399",
  },

  dividers: {
    main: "#0000001f",
  },
  auth: {
    forgotPasswordMain: "#8c5ae6",
  },
  alerts: {
    confirm: "#2a9844",
    cancel: "#d33",
  },
  professor: {
    pageBackground: "#1a2536",
    checkboxUnchecked: "#4b5563",
    link: "#93c5fd",
    blue: "#002184",
    banner: {
      surface: "#123524",
      border: "#1e5a3a",
      text: "#86efac",
      icon: "#34d399",
    },
    groups: {
      pedagogical: {
        orange: "#FF641A",
        purple: "#7300A8",
        green: "#389937",
        blue: "#2945F5",
        gray: "#6B6F78",
      },
    },
  },
}

export const getPalette = (mode = "light") => ({
  mode,
  ...palette,
  ...(mode === "dark" ? darkPalette : {}),
})

export { palette }
